<template>
<b-container fluid style="padding-left:0; padding-right:0;">
	<latest-post-streamer />
<b-container class="mt-4">
	<b-row>
		<b-col md="10" offset-md="1">
			<h1 class="text-center" style="font-size: 4.5em; font-weight: 300;">Hvorfor skal jeg vælge <span style="font-weight: 400;">SkvizBiz</span>?</h1>
		</b-col>
	</b-row>
	<!-- START THE FEATURETTES -->

	<hr class="featurette-divider" style="opacity:0;">
	<b-row align-v="center" class="has-background">
		<div class="background"><lazy-image :src="require('~/assets/images/bigbox-savetime-optimized.jpg')" /></div>
		<b-col md="3" order-md="1" class="text-center">
			<!-- <lazy-image rounded="circle" height="150px" width="150px" :src="require('~/assets/images/bigbox-savetime.jpg')" /> -->
			<undraw-finance primary-color="#4fc3f7" height="150" />
		</b-col>
		<b-col md="9">
			<h2 class="featurette-heading" id="save_time">Fordi du kommer til at spare både tid og penge</h2>
			<p class="lead">
				Du vil <a @click="handle_hash" href="/hvorfor#flere-grunde/spar-tid">spare tid på kundestyring, ruteplanlægning</a>, <a @click="handle_hash" href="/hvorfor#flere-grunde/medarbejdere">administration af medarbejdere</a>, <a @click="handle_hash" href="/hvorfor#flere-grunde/alt-i-en">regnskab</a> og andet kontorarbejde, så du kan bruge tiden på sjovere eller mere indbringende ting.<br>Og du vil spare penge ved at <a @click="handle_hash" href="/hvorfor#flere-grunde/registrer-betalinger">få bedre styr på indbetalinger</a>, <a @click="handle_hash" href="/hvorfor#flere-grunde/rykkere">dårlige betalere</a>, <a @click="handle_hash" href="/hvorfor#flere-grunde/rykkere">rykkere</a> og budgetplanlægning. Du kan også let <a @click="handle_hash" href="/hvorfor#flere-grunde/medarbejdere">styre provisionsberegning</a>, hvis du har ansatte eller underleverandører.
			</p>
		</b-col>
	</b-row>
	
	<hr class="featurette-divider" style="opacity:0;">
	
	<b-row align-v="center">
		<b-col md="3" order-md="0" class="text-center">
			<!-- <lazy-image rounded="circle" height="150px" width="150px" :src="require('~/assets/images/bigbox-savetime.jpg')" /> -->
			<undraw-map-light primary-color="#4fc3f7" height="150" />
		</b-col>
		<b-col md="9">
			<h2 class="featurette-heading" id="route_optimizing">Optimering af ruter</h2>
			<p class="lead">
				Med SkvizBiz' automatiske ruteoptimering kan du spare tid og brændstof. SkvizBiz kan nemlig hjælpe dig med at lægge dine kunder i rækkefølge efter deres placering, så du kommer til at køre mindre mellem kunderne.<br>
				Så kan du bruge mere tid på at pudse vinduer, og mindre tid på at køre ... og på at tanke. Ifølge vores statistik kan vores brugere nemlig gennemsnitligt <strong>spare næsten 30% af de kørte kilometer</strong>, ved at bruge vores automatiske ruteoptimering. Og <strong>tiden på vejene bliver ca. 25% mindre!</strong>
			</p>
		</b-col>
	</b-row>
	
	<hr class="featurette-divider">
	
	<b-row align-v="center">
		<b-col md="3" order-md="1" class="text-center">
			<!-- <div class="text-center" style="font-size: 12em; margin-top:-40px; margin-bottom: -40px;"><fa :icon="['far', 'smile']" /></div> -->
			<undraw-hello primary-color="#4fc3f7" height="170" />
		</b-col>
		<b-col md="9">
			<h2 class="featurette-heading" id="service">God service</h2>
			<p class="lead">
				SkvizBiz hjælper dig også på mange andre områder. Din virksomhed vil fremstå mere professionel og kunne yde en bedre service overfor kunderne. Du vil i højere grad kunne koncentrere dig om at udføre dit arbejde. Og du vil få helt nye muligheder, som fx at <a @click="handle_hash" href="/hvorfor#flere-grunde/moduler">opkræve penge via Betalingsservice</a> eller <a @click="handle_hash" href="/hvorfor#flere-grunde/moduler">sende påmindelser til kunderne på SMS</a>
			</p>
		</b-col>
	</b-row>

	<!--
	<hr class="featurette-divider">

	<b-row align-v="center">
		<b-col md="7" order-md="1">
			<h2 class="featurette-heading" id="tailored">Skræddersyet til branchen</h2>
			<p class="lead">
				SkvizBiz er udviklet i samarbejde med en lang række virksomheder, der tilbyder vinduespolering, rengøring og lignende serviceydelser, og programmet er på den måde skræddersyet til branchen.
			</p>
		</b-col>
		<b-col md="5">
			<b-carousel id="quote-carousel" style="height: 180px; min-width: 320px;">
				<b-carousel-slide style="height: 180px;">
					<blockquote class="text-left text-secondary">
						<p><a @click="handle_hash" href="/hvorfor#flere-grunde/udtalelser-fra-andre">Jeg var simpelthen ikke selvstændig vinduespudser hvis ikke det havde været for SkvizBiz.</a></p>
						<small>&nbsp;&ndash;&nbsp;Dyrvig Vinduespolering</small>
					</blockquote>
				</b-carousel-slide>
				<b-carousel-slide style="height: 180px;">
					<blockquote class="text-left text-secondary">
						<p><a @click="handle_hash" href="/hvorfor#flere-grunde/udtalelser-fra-andre">Jeg var lidt nervøs over at skulle skifte, men det er det bedste jeg har gjort!</a></p>
						<small>&nbsp;&ndash;&nbsp;JF Polering</small>
					</blockquote>
				</b-carousel-slide>
				<b-carousel-slide style="height: 180px;">
					<blockquote class="text-left text-secondary">
						<p><a @click="handle_hash" href="/hvorfor#flere-grunde/udtalelser-fra-andre">Hvor er jeg bare tilfreds med SkvizBiz! I gør det virkelig godt med jeres konstante udvikling! Jeg anbefaler andre dette program hver gang jeg kan komme til det!</a></p>
						<small>&nbsp;&ndash;&nbsp;Thomas Maxim, Maxim Vinduespolering</small>
					</blockquote>
				</b-carousel-slide>
			</b-carousel>
		</b-col>
	</b-row>
	-->

	<hr class="featurette-divider" style="opacity:0;">

	<b-row align-v="center" class="has-background">
		<div class="background"><lazy-image :src="require('~/assets/images/night-computer-hdd-hard-drive.jpg')" style="transform: translateY(-23%)" /></div>
		<b-col md="3" order-md="1" class="text-center">
			<!-- <div class="text-center" style="font-size: 10em; margin-top:-20px; margin-bottom: -20px;"><fa :icon="['fas', 'lock']" /></div> -->
			<undraw-security primary-color="#4fc3f7" height="150" />
			<!-- <img class="featurette-image img-responsive center-block" data-src="holder.js/500x500/auto" alt="500x500" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNTAwIiBoZWlnaHQ9IjUwMCIgdmlld0JveD0iMCAwIDUwMCA1MDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjwhLS0KU291cmNlIFVSTDogaG9sZGVyLmpzLzUwMHg1MDAvYXV0bwpDcmVhdGVkIHdpdGggSG9sZGVyLmpzIDIuNi4wLgpMZWFybiBtb3JlIGF0IGh0dHA6Ly9ob2xkZXJqcy5jb20KKGMpIDIwMTItMjAxNSBJdmFuIE1hbG9waW5za3kgLSBodHRwOi8vaW1za3kuY28KLS0+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsjaG9sZGVyXzE1MWM1ZDI0YjljIHRleHQgeyBmaWxsOiNBQUFBQUE7Zm9udC13ZWlnaHQ6Ym9sZDtmb250LWZhbWlseTpBcmlhbCwgSGVsdmV0aWNhLCBPcGVuIFNhbnMsIHNhbnMtc2VyaWYsIG1vbm9zcGFjZTtmb250LXNpemU6MjVwdCB9IF1dPjwvc3R5bGU+PC9kZWZzPjxnIGlkPSJob2xkZXJfMTUxYzVkMjRiOWMiPjxyZWN0IHdpZHRoPSI1MDAiIGhlaWdodD0iNTAwIiBmaWxsPSIjRUVFRUVFIi8+PGc+PHRleHQgeD0iMTg1LjEyNSIgeT0iMjYxLjEiPjUwMHg1MDA8L3RleHQ+PC9nPjwvZz48L3N2Zz4=" data-holder-rendered="true"> -->
		</b-col>
		<b-col md="9">
			<h2 class="featurette-heading" id="security">Høj datasikkerhed</h2>
			<p class="lead">
				<a @click="handle_hash" href="/hvorfor#flere-grunde/datasikkerhed">Du får adgang til dine data overalt</a> - Det eneste, der kræves, er internetadgang. Programmet virker både på Windows, Mac, Linux, samt på nyere udgaver af iPhone og Android-smartphones.
				<br>
				De sidste tre måneder har vi haft {{uptime}} oppetid!<!-- <lazy-image src="https://app.statuscake.com/button/index.php?Track=jhSZdYAdH2&Days=30&Design=1" width="100" height="20" /> -->
			</p>
		</b-col>
	</b-row>

	<hr class="featurette-divider" style="opacity:0;">

	<b-row id="flere-grunde">
		<b-col md=10 offset-md="1">
			<h2 class="featurette-heading">Stadig ikke overbevist?</h2>
			<p class="lead">
				Vælg mellem punkterne i herunder for at læse mere om, hvordan SkvizBiz vil <a href="/hvorfor#flere-grunde/bedre-overblik" @click="handle_hash">lette administrationen af din forretning</a>. Husk at læse <a href="/hvorfor#flere-grunde/udtalelser-fra-andre" @click="handle_hash">hvad vores brugere synes</a> om programmet. Du kan også lære mere ved at <a href="/videoer">se vores videoer</a>, eller du kan <a href="/tilmelding">bestille en gratis demo-konto</a>.
			</p>
		</b-col>
	</b-row>
	<b-row class="mt-3">
		<b-col>
			<b-card no-body bg-variant="light">
				<b-tabs pills card vertical lazy v-model="tabIndex" ref="more_reasons">
					<b-tab active title="Hør hvad brugerne siger" href="#udtalelser-fra-andre">
						<h1>Skræddersyet til branchen</h1>
						<p>SkvizBiz er udviklet i samarbejde med en lang række virksomheder, der tilbyder vinduespolering, rengøring og lignende serviceydelser, og programmet er på den måde skræddersyet til branchen.</p>

						<h2>Hør hvad brugerne siger
						</h2>
						<p>"Jeg skiftede til SkvizBiz efter at have brugt C5 i 10 år. Jeg var lidt nervøs over at skulle skifte, da vi alle jo ved regnskab og kunde database er meget vigtige og fortrolige oplysninger. Men jeg vil sige, det er det bedste jeg har gjort. Programmet fungerer perfekt. Rutestyringen og rykkerfunktionen er fantastisk, da det hele bare kører automatisk. Jeg har kun godt at sige som SkvizBiz, og har man nogle ting man synes kunne være nyttige som ikke er i programmet, er de lydhøre og som oftest kommer det med i den næste opdatering."
						<br>- Jesper Farsø, <a href="http://www.jfpolering.dk" target="_blank">www.jfpolering.dk</a>
						<br>
						</p>
						<p>"Jeg kan ligeså godt sige det som det er: Jeg var simpelthen ikke selvstændig vinduespudser hvis ikke det havde været for SkvizBiz. Jeg tog hellere støtten end sidde og rode med det manuelt. KH Richo B."
						<br> - Richo Dyrvig, <a href="http://www.dyrvig-vp.dk" target="_blank">www.dyrvig-vp.dk</a>
						</p>
						<p>"Jeg plejer at sidde søndag formiddag og hente betalinger hjem fra GiroBank, printe dem ud på hver sit a6, sortere dem efter ruter, finde hver kunde i ruten, og krydse af at de har betalt. Nu har jeg lige hentet ugens betalinger, hentet dem ind i SkvizBiz, trykket opdater, og, BLING, det samme er klaret på under 3 min."
						<br>&nbsp;- Lars Hansen - <a href="http://www.a3-polering.dk/" target="_blank">www.a3-polering.dk</a>
						</p>
						<p class=" ">"SkvizBiz er et helt igennem fantastisk program, ganske unikt, det opfylder alle de krav jeg havde til et vinduespudserprogram. Det er en stor hjælp i hverdagen, og sparer mig for meget tid, samt hjælper mig med at holde styr på kunder, aftaler, osv. og ikke mindst, om kunderne betaler rettidigt. Supporten hos SkvizBiz' udviklere Vikiallo er også til 5 stjerner, ingen lange tlf. ventetider, man kommer til med det samme, og de hjælper en med spørgsmål eller problemer på en meget hurtig og professionel måde. Jeg kan kun sige, at hvis du ønsker mere tid og overblik i din hverdag, så skal du vælge SkvizBiz"
						<br>&nbsp;- Carsten Allesø - <a href="http://www.ca-polering.dk/" target="_blank">www.ca-polering.dk</a>
						</p>
						<p>"Det jeg har erfaret indtil videre er intet mindre end imponerende, i forhold til de systemer vi tidligere har kørt med. Vi har ikke sendt en eneste faktura med posten endnu. Alt bliver sendt via e-mail. (Vi har rengøringskunder, boligforeninger, byggefirmaer og andet, og kun enkelte ruter til vinduespudsning)
						<br>Der har været 100% glæde og tilfredshed hos kunderne. Vi sparer porto, og vi glemmer ikke at poste brevene. Vi tager vort "firma" med på ferie, og kan ordne div. ting dér, når tiden bliver for lang. (Man kan også lade være jo). Og så har vi aldrig oplevet bedre og billigere service i forbindelse med IT. Vi skal nok prøve at spejde efter noget negativt, men den bliver svær. ;-) Nu glæder vi os til at komme videre med at lære det hele bedre at kende. Nå ja... så kan man jo ikke lade være med at tale om det til højre og venstre. Det er nok lidt belastende for vores omgivelser, men det er jo et offer vi må bringe."
						<br>&nbsp;- Bjarne Poulsen - <a href="http://bpvinduespolering.dk/" target="_blank">www.bpvinduespolering.dk</a>
						</p>
						<p>"Hvor er jeg bare tilfreds med SkvizBiz! I gør det virkelig godt med jeres konstante udvikling! Jeg anbefaler andre dette program hver gang jeg kan komme til det!"
						<br>&nbsp;- Thomas Maxim <a href="http://www.maximvinduespolering.dk" target="_blank">www.maximvinduespolering.dk</a>
						</p>
						<p>"Tak for hjælpen. Er virkelig glad for alt det programmet kan. Det sparer tid i det daglige!"
						</p>
						<p>"Tidligere sad min hustru og jeg tilsammen ca. 60 timer ugentligt for at styre vores kunder, ruter, medarbejdere, provisionsberegning, rykkere&nbsp;og indbetalinger. Nu har vi svært ved at bruge mere end 8 timer ugentligt. SkvizBiz har tjent sig hjem mange gange, allerede den første måned".
						</p>
						<p>"Jeg har længe villet skifte de manuelle indbetalingskort ud, men de programmer, der har været skræddersyet til branchen, har været alt for dyre. Dejligt at I har lavet SkvizBiz. Den kan det, jeg har brug for, til en meget fornuftig pris."
						<br>
						<br>"Min største udfordring er at holde styr på hvem der har betalt og så få rykket dem, der ikke har betalt. At SvizBiz gør dette automatisk er en meget stor hjælp."
						<br>
						<br>"Med SkvizBiz får jeg mindre papirarbejde og bedre styr på mine kunder."
						<br>
						<br>"Hvor er det smart at jeg kan udskrive alle indbetalingskort og fakturaer på én gang til en hel rute, i stedet for at skulle udskrive til hver enkelt kunde."
						<br>
						<br>"Før skrev jeg mine indbetalingskort i hånden, nu ser de mere professionelle ud og det går meget hurtigere."
						<br>
						<br>"Det er fedt, at jeg ikke skal installere et program - jeg går bare på nettet og taster min kode ind, og så er jeg i gang."
						</p>
						<p>"Tidligere sad jeg hver weekend i 5 til 6 timer for at forsøge at finde ud af indbetalinger, hvem der skulle rykkes, planlægge næste uges arbejde og skrive fakturaer ud. Nu tager det max 30 minutter."
						</p>
					</b-tab>
					<b-tab title="Spar masser af tid med SkvizBiz" href="#spar-tid">
						<h1>Spar masser af tid med SkvizBiz
						</h1>
						<p>Bruger du for meget tid på kontoret? Ville du hellere bruge tiden på at være ude og tjene penge, eller på at holde fri med familien? SkvizBiz er planlægningsværktøjet, som du ikke har råd til at undvære, hvis du lever af at pudse vinduer eller gøre rent.
						</p>
						<p><lazy-image style="margin: 4px;" title="Overskuelig planlægning i kalenderen" alt="Overskuelig planlægning i kalenderen" :src="require('~/assets/images/kalender-overskuelig-planlaegning.jpg')" align="right" height="205" width="300" />Med det smarte planlægnings- og faktureringsværktøj i SkvizBiz kan du <strong>nemt planlægge arbejdet for en dag eller en hel uge ad gangen</strong>, og så udskrive alle fakturaer eller indbetalingskort på én gang. Samtidig får du en overskuelig ruteplan med alle de opgaver, du skal udføre. Efter et par minutter er du klar til at køre ud på ruten. Hvis du i dag skriver dine indbetalingskort i hånden eller fakturerer manuelt fra computeren, er her virkelig tid at spare.
						</p>
						<p>Hvis du oven i det lægger, at du kan <a @click="handle_hash" href="/hvorfor#flere-grunde/registrer-betalinger"><strong>afstemme indbetalinger fra kunderne på 5 minutter om ugen</strong></a>, og at du kan <a @click="handle_hash" href="/hvorfor#flere-grunde/bedre-overblik">spare tid på planlægning</a> ved at lade programmet holde styr på hvilke opgaver, der skal udføres - ja så er vi sikre på at du kommer frem til, at du kan spare flere timer hver eneste uge.
						</p>
						<p>Du vil opdage, at SkvizBiz skærer ned i dit kontorarbejde allerede fra dag 1 - og med få klik giver vi dig mere overblik end du troede muligt.
						<br>
						</p>
					</b-tab>
					<b-tab title="Bedre overblik over din forretning" href="#bedre-overblik">
						<h1>Få bedre overblik over din forretning
						</h1>
						<p>Drømmer du om at få mere styr på hvad du skal lave hvornår? Vil du gerne let kunne overskue om du har tid til at tage ekstra arbejde ind? Vil du gerne have mere styr hvad der kommer af indtægter den kommende måned?
						</p>
						<p>I SkvizBiz' smarte og overskuelige kalender får du lynhurtigt et rigtig <strong>godt overblik over dine&nbsp; arbejdsopgaver</strong>. Med få klik kan du planlægge din tid effektivt, og du kommer hurtigt til at <a @click="handle_hash" href="/hvorfor#flere-grunde/roi">spare timer hver uge</a>. Kalenderen giver dig samtidig <strong>overblik over din omsætning</strong>, så du nemt kan aflæse hvad du kommer til at tjene i de kommende uger og måneder.
						<br>
						</p>
						<p><lazy-image style="margin: 4px;" title="Nem kundestyring for vinduespudsere" alt="Nem kundestyring for vinduespudsere" :src="require('~/assets/images/kundestyring-for-vinduespudsere.jpg')" align="right" height="205" width="300" />Programmet holder automatisk styr på hvilke opgaver, der skal udføres hvornår, og i hvilken rækkefølge det er mest effektivt at udføre dem. Du kan uden problemer oprette flere aftaler på samme kunde, og hvis en kunde for eksempel kun skal have pudset vinduer indvendig hver anden gang, så holder SkvizBiz også styr på det. Hvis der kommer en undtagelse og en kunde skal have pudset vinduer en ekstra gang eller gerne vil springe over, kan du let taste det ind i arbejdskalenderen på forhånd, og programmet husker det for dig.
						</p>
						<p>SkvizBiz har en indbygget helligdagskalender, og du kan selvfølgelig selv vælge, på hvilke helligdage du vil holde fri. Du kan også selv indsætte ferie, og holder du fx sommerferie i et par uger, kan du vælge at programmet skal skubbe dine aftaler i kalenderen, så du ikke er bagud, når du kommer hjem igen.
						</p>
						<p> <strong>Kort sagt holder programmet styr på alt det kedelige for dig, så du kan koncentrere dig om det du er god til. </strong>
						<br>
						</p>
					</b-tab>
					<b-tab title="Hold styr på hvem der har betalt" href="#registrer-betalinger">
						<h1>Afstem indbetalinger på 5 minutter
						</h1>
						<p>Hvor meget tid bruger du hver uge på at afstemme indbetalinger fra dine kunder? Kunne du tænke dig at klare det på 5 minutter om ugen, og samtidig få komplet overblik over eventuelle dårlige betalere? Hvis det lyder interessant, så har SkvizBiz løsningen til dig.
						</p>
						<p>
						</p>
						<p>På få minutter indlæser du en fil fra din bank, og <strong>SkvizBiz genkender og afstemmer automatisk indbetalinger fra kunderne</strong>. Første gang du prøver det, vil du helt sikkert tænke: "Har programmet virkelig lige klaret det, som jeg selv plejer at bruge timer på?" Men vi er sikre på at du hurtigt vil vænne dig til hvor hurtigt det går.
						</p>
						<p>
						</p>
						<p>SkvizBiz kan indlæse filer fra alle danske banker. Selvfølgelig kan du også nemt holde styr på kontantbetalinger og eventuelle indbetalinger via Betalingsservice.
						</p>
						<p><lazy-image style="margin: 4px;" title="Afstem indbetalinger og se det på kontoudtoget" alt="Afstem indbetalinger og se det på kontoudtoget" :src="require('~/assets/images/kontoudtog.jpg')" align="right" height="205" width="300" />Du kan nemt få vist et kontoudtog for en hvilken som helst kunde, og kontoudtoget kan udskrives eller sendes som email til kunden, hvis der opstår tvivl.
						<br>
						</p>
						<p>Programmet giver dig med få klik overblik over alle de kunder, som skylder dig penge, så du kan følge op på de dårlige betalere og eventuelt sende en <a @click="handle_hash" href="/hvorfor#flere-grunde/rykkere">betalingspåmindelse eller rykker</a>.
						<br>
						</p>
					</b-tab>
					<b-tab title="Saml regnskab og administration" href="#alt-i-en">
						<h1>Saml regnskab og administration
						</h1>
						<p> Bruger du i dag tid på at sidde og indtaste alle dine indtægter og udgifter i et regnskabssystem? Eller betaler du din revisor i dyre domme for at gøre det?
						<br> Måske har du i dag kundestyring, fakturering og regnskab adskilt i to eller flere systemer, og er tvunget til at indtaste nogle af de samme oplysninger flere steder? Med SkvizBiz får du det hele samlet ét sted, og du slipper for irriterende dobbeltarbejde.
						<br>Og SkvizBiz er godkendt af erhvervsstyrelsen som standardbogføringssystem (registreringsnummer <code><a href="/registreringsbevis.pdf" target="_blank" style="font: inherit; background: inherit; color: inherit">fob668761</a></code>), så du kan stole på at datasikkerheden er i top, og at programmet kan det et regnskabsprogram skal kunne.
						</p>
						<p>
						</p>
						<p>Når man vælger SkvizBiz er finansmodulet altid tilkoblet, og det gør SkvizBiz til et fuldt fungerende regnskabsprogram. Når du fakturerer og når kunder indbetaler, bliver det naturligvis <strong>automatisk bogført i regnskabet</strong>, så du slipper for at taste det to gange.
						</p>
						<p><lazy-image style="margin: 4px;" title="Konter også nemt udgifter i kassekladden" alt="Konter også nemt udgifter i kassekladden" :src="require('~/assets/images/kassekladde-regnskab.jpg')" align="right" height="205" width="300" />Noget af det smarteste er, at når du alligevel <a @click="handle_hash" href="/hvorfor#flere-grunde/registrer-betalinger">indlæser kunders indbetalinger</a> fra banken, så kan du også tage dine udgifter med ind i samme arbejdsgang. Når en udgift indlæses, kender programmet både dato, tekst og beløb fra banken. Derfor skal du kun vælge hvilken omkostningskonto, udgiften skal bogføres på, og så finder programmet ud af resten. <strong>Du slipper for at taste det hele</strong> og minimerer risikoen for tastefejl. Samtidig går det så hurtigt, at det ikke behøver være noget man udskyder til absolut sidste øjeblik.
						</p>
						<p>Når der skal laves momsregnskab eller balance for året, eller når du bare gerne vil have et overblik over hvordan forretningen går, så beder du bare programmet om de ønskede tal, og få sekunder senere har du <a @click="handle_hash" href="/hvorfor#flere-grunde/bedre-overblik"><strong>et komplet overblik</strong></a>.
						</p>
					</b-tab>
					<b-tab title="Styring af medarbejdere" href="#medarbejdere">
						<h1>Styr arbejde og provision til medarbejdere
						</h1>
						<p>Hvis du har en eller flere ansatte i din virksomhed, har du helt sikkert mødt nogle problemstillinger i den forbindelse. Også her kan SkvizBiz hjælpe dig.
						</p>
						<p>Hver medarbejder får en separat arbejdskalender i programmet. På den måde kan du holde hver medarbejders kunder og opgaver adskilt, men du kan også nemt flytte opgaver mellem dine medarbejdere, når det er nødvendigt.
						</p>
						<p>Hvis dine medarbejdere er provisionslønnede, så kan SkvizBiz være en stor hjælp. Du kan vælge en procentsats for hver af dine medarbejdere, men du kan selvfølgelig også vælge at enkelte kunder eller opgaver skal give en større eller mindre provision. Du får <strong>let overblik over hvad dine medarbejdere skal have udbetalt</strong>, uden at du skal huske 117 ting i hovedet eller have skrivebordet tilklistret med gule sedler.
						<br>
						</p>
						<p>Du kan endda give medarbejderne adgang til selv at logge ind på programmet. Du har naturligvis fuld kontrol over hvad de må se og om de må ændre noget. Du kan blandt andet vælge at medarbejderen selv må færdigmelde sine ruter, se hvor meget provision han har opsparet, oprette kunder m.m.
						<br>
						</p>
					</b-tab>
					<b-tab title="SMS, E-faktura og Betalingsservice" href="#moduler">
						<h1>SMS, E-faktura og Betalingsservice
						</h1>
						<p> SkvizBiz giver dig mulighed for at yde dine kunder endnu bedre service, uden at det koster dig en masse tid. Programmet har indbyggede moduler til afsendelse af SMS og E-faktura, mens Betalingsservice er et tilkøbsmodul.
						</p>
						<h2>Afsendelse af SMS
						</h2>
						<p>Mobiltelefonen er blevet et kraftigt værktøj, som flere og flere virksomheder udnytter kreativt i deres forretning. Med SkvizBiz kan du være med. Du kan vælge at sende en SMS til dagens kunder inden du kører ud på ruten. Fx kan kunden få at vide at du skal pudse vinduerne indvendig, så han kan sørge for at der er låst op når du kommer. Hvis du i dag ringer til kunderne inden du kører ud, kan du spare meget tid her.
						<br>Du kan også vælge at sende en SMS og informere kunden når du har været der. Og flere har haft stor succes med at sende en venlig betalingspåmindelse på SMS til dårlige betalere.
						</p>
						<h2>Afsendelse af E-faktura
						</h2>
						<p>Hvis du har offentlige kunder, kender du helt sikkert til problematikken omkring afsendelse af fakturaer i E-faktura-formatet. Måske bruger du i dag tid på manuelt at sende disse fakturaer via virk.dk. Med SkvizBiz kan du spare tid ved at sende E-faktura direkte fra programmet.
						<br>
						</p>
						<h2>Opkrævning via Betalingsservice
						</h2>
						<p>Mange af vores brugere er blevet rigtig glade for at kunne tilbyde deres kunder at opkræve betalinger via Betalingsservice. SkvizBiz laver benarbejdet og holder styr på, hvem der er tilmeldt, og hvem der skal opkræves hvor meget. Flere har erfaret at kunderne er glade for denne service, og at det hjælper til at fastholde kunder i krisetider.
						<br>
						</p>
						<p>Du kan læse hvad det koster at bruge disse smarte funktioner på siden <a href="/priser">Priser</a>.
						</p>
					</b-tab>
					<b-tab title="Send rykkere til dårlige betalere" href="#rykkere">
						<h1>Send rykkere til dårlige betalere
						<br>
						</h1>
						<p><lazy-image style="margin: 4px;" title="Hold dårlige betalere i kort snor med rykkerfunktionen" alt="Hold dårlige betalere i kort snor med rykkerfunktionen" :src="require('~/assets/images/udskriv-rykkere-til-daarlige-betalere.jpg')" align="right" height="205" width="300" />Har du problemer med kunder, som er ikke betaler til tiden? Det har du helt sikkert. SkvizBiz kan ikke gøre alle dine dårlige betalere til gode betalere, men programmet kan holde styr på dem for dig, og i hvert fald hjælpe med at få nogle af pengene ind. SkvizBiz har to store fordele, når det kommer til styring af dårlige betalere:
						</p>
						<p>For det første giver programmet dig mulighed for at <strong>udskrive betalingspåmindelser og rykkere</strong> til de dårlige betalere, enten automatisk eller manuelt. Mange indbetaler når de får en påmindelse, så her kan du <strong>minimere dit tab og spare penge</strong>.
						<br>Samtidig kan du tjene lidt ekstra penge på at tilskrive rykkergebyrer til de dårlige betalere. Du har helt frie hænder til at vælge, hvordan du vil rykke dine kunder, og om du ønsker at bruge rykkergebyrer.
						<br>
						</p>
						<p>For det andet hjælper programmet dig med at <strong>opdage dårlige betalere i tide</strong>, så du ikke kommer til at udføre arbejde mange gange hos en kunde, der alligevel ikke betaler.
						</p>
						<p>Det er noget af det mest frustrerende at have udført et stykke arbejde, som man ikke bliver betalt for. Lad SkvizBiz hjælpe dig med at minimere tabet på dårlige betalere.
						<br>
						</p>
					</b-tab>
					<b-tab title="Programmet tjener sig hurtigt ind" href="#roi">
						<h1>En investering der hurtigt betaler sig
						</h1>
						<p>Kan det betale sig at købe SkvizBiz? Det mener vi helt bestemt at det kan. Hvad enten du er nystartet eller gammel i gårde, vil du kunne spare både timer og kroner på at bruge SkvizBiz.
						</p>
						<p> Hver gang du bruger en time på kontoret, har du en time mindre til at pudse vinduer, gøre rent eller måske holde lidt ekstra fri. SkvizBiz barberer toppen af din administration, og du kommer til at spare mange timer.
						<br>
						</p>
						<p style="margin: 0;">Samtidig sparer SkvizBiz penge for dig på flere områder:
						</p>
						<ul>
						<li><a @click="handle_hash" href="/hvorfor#flere-grunde/alt-i-en">Du har kun brug for ét program</a>, så hvis du i dag betaler til flere forskellige programmer, kan du spare det væk</li>
						<li>Du kommer til at <a @click="handle_hash" href="/hvorfor#flere-grunde/rykkere">tabe færre penge på dårlige betalere</a></li>
						<li>Du kan <a @click="handle_hash" href="/hvorfor#flere-grunde/rykkere">tjene penge på at udskrive rykkergebyrer</a></li>
						<li>Du kan <a @click="handle_hash" href="/hvorfor#flere-grunde/alt-i-en">spare dyre timer fra din revisor</a> med det smarte finansmodul.</li>
						<li>Du kan <a @click="handle_hash" href="/hvorfor#flere-grunde/spar-tid">spare penge ved at optimere dine ruter</a>, så du ikke spilder unødig tid.
						<br></li>
						<li>Hvis du i dag har en dyr aftale med din bank for at kunne udlæse filer til dit nuværende regnskabsprogram, kan dette sandsynligvis spares væk.</li>
						</ul>
						<p>
						<br>Vi kan komme i tanker om mange flere gode grunde til at SkvizBiz er det rigtige program til dig. Hvis du stadig er lidt i tvivl, så ring eller skriv til os og få en snak om, hvordan SkvizBiz kan hjælpe netop din forretning. Vores kontaktoplysninger finder du i bunden af siden.
						<br>
						</p>
						<p>
						</p>
					</b-tab>
					<b-tab title="Dine data bliver sikret" href="#datasikkerhed">
						<h1>Datasikkerhed og tekniske oplysninger
						</h1>
						<p>SkvizBiz er en online løsning, hvilket gør at du kan få <strong>adgang til dine data overalt</strong>, bare du har forbindelse til Internettet. Det gør også at programmet kan køre på alle moderne styresystemer, både Windows, Mac, Linux samt nyere udgaver af iPhone og Android-smartphones.
						</p>
						<p>Det eneste krav til maskinen, er at du skal bruge en nyere internetbrowser. SkvizBiz er testet og virker sammen med disse browsere:
						</p>
						<ul>
						<li>Firefox (version 29 eller nyere)</li>
						<li>Microsoft Edge (version 18 eller nyere)</li>
						<li>Safari (version 13 eller nyere)</li>
						<li>Google Chrome (version 33 eller nyere)
						<br></li>
						</ul>
						<p>
						<br>Det betyder også at hvis du skifter computer (eller hvis din computer brænder sammen), så kører din SkvizBiz upåklageligt videre.
						<br>
						</p>
						<p>Vi har servere installeret tre forskellige steder i Kolding. De benytter flere forskellige internetforbindelser og har UPS nødstrømsforsyning. Der bliver taget <strong>backup af dine data</strong> mange gange hver dag, så selvom en harddisk i en server skulle fejle (eller strømmen svigter i hele Jylland :-)) kører din SkvizBiz fortsat videre.
						</p>
						<p>Dine data får deres eget sikre område på vores server, som kun du har adgang til. Vi sørger også for backup og antivirus-beskyttelse. Vi har gjort alt hvad der realistisk er muligt for at komme så tæt på 100% oppetid som muligt, og de sidste tre måneder har vi haft {{uptime}} oppetid.
						</p>
					</b-tab>
				</b-tabs>
			</b-card>
		</b-col>
	</b-row>
</b-container>
</b-container>
</template>

<script>
/**
 * @see https://undraw.co/search
 */

import {
	BContainer,
	BRow,
	BCol,
	BCarousel,
	BCarouselSlide,
	BCard,
	BTabs,
	BTab,
} from "bootstrap-vue";

import UndrawMapLight from '~/node_modules/vue-undraw/UndrawMapLight.vue';
import UndrawHello from '~/node_modules/vue-undraw/UndrawHello.vue';
import UndrawFinance from '~/node_modules/vue-undraw/UndrawFinance.vue';
import UndrawSecurity from '~/node_modules/vue-undraw/UndrawSecurity.vue';
// import UndrawSafe from '~/node_modules/vue-undraw/UndrawSafe.vue';

import LazyImage from "~/components/LazyImage";
import axios from "axios";

export default {
	components: {
		BContainer,
		BRow,
		BCol,
		BCarousel,
		BCarouselSlide,
		BCard,
		BTabs,
		BTab,

		LazyImage,
		UndrawMapLight,
		UndrawHello,
		UndrawFinance,
		UndrawSecurity,
		LatestPostStreamer: () => import("~/components/LatestPostStreamer.vue"),
	},
	data() {
		return {
			tabIndex: 0,
			uptime: "[ indlæser ...]",
		};
	},
	methods: {
		selectTab(name) {
			if (!this.$refs.more_reasons) {
				return;
			}
			if (!name) {
				return;
			}
			let map = {};
			let tabs = this.$refs.more_reasons.tabs;
			tabs.forEach((tab, index) => {
				if (tab.$attrs && tab.$attrs.href) {
					let href = tab.$attrs.href.substr(1);
					if (href) {
						map[href] = index;
					}
				}
			});
			this.tabIndex = map[name] || 0;
		},
		async handle_hash() {
			await new Promise(resolve => {
				setTimeout(resolve, 100);
			});
			let hash = this.$route.hash;

			const findEl = async (hash, x) => {
				return (
					document.querySelector(hash) ||
					new Promise((resolve, reject) => {
						if (x > 50) {
							return resolve();
						}
						setTimeout(() => {
							resolve(findEl(hash, ++x || 1));
						}, 100);
					})
				);
			};

			let tab = hash.replace(/[^/]*\//, "");
			this.selectTab(tab);

			if (hash.replace(/\/.*/, "")) {
				let el = await findEl(hash.replace(/\/.*/, ""));
				if ("scrollBehavior" in document.documentElement.style) {
					return window.scrollTo({
						top: el.offsetTop - 70,
						behavior: "smooth",
					});
				} else {
					return window.scrollTo(0, el.offsetTop - 70);
				}
			}
		},
		async get_uptime() {
			try {
				let data = await axios.get("https://status.skvizbiz.dk/api/v1/public-status").then(response => response.data);
				if (data && data.services) {
					let service = data.services.find(service => service.id == 13);
					if (service.uptime.toFixed(3) === "100.000") {
						this.uptime = `100%`;
					} else {
						this.uptime = `${service.uptime.toFixed(3).replace(".",",")}%`;
					}
				}
			} catch (err) {
				console.log(err)
			}
		},
	},
	mounted() {
		this.handle_hash(/* this.$route.hash */);
		this.get_uptime();
	},
	watch: {
		// '$route.hash'(newValue) {
		// 	this.handle_hash(newValue);
		// },
	},
};
</script>


<style lang="scss">
.has-background {
	position: relative;

	.background {
		overflow: hidden;
		width: 100vw;
		height: calc(100% + 30px);
		margin-top: -17px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;

		img {
			opacity: 0.35;
			// -webkit-filter: blur(5px);
			// filter: blur(5px);
			min-height: calc(100% + 40px);
			width: calc(100% + 40px);
			margin-left: -5px;
			margin-top: -10px;
		}
		position: absolute;
	}

	.featurette-heading,
	.lead {
		color: black;
		background: rgba(255, 255, 255, 0.8);
		// background-color: #f2fbff88;
		// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Cpath fill='%23bbe9fd' fill-opacity='0.3' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E%3C/path%3E%3C/svg%3E");
		border-radius: 4px;
		width: auto;
		display: inline-block;
		padding: 0px 10px 2px;
	}
}

.featurette-divider {
	margin-top: 30px;
	margin-bottom: 30px;
}

.tabs {
	.nav-link {
		transition: background-color 0.2s ease-out, color 0.2s ease-out;
	}
}

#quote-carousel {
	.carousel-inner {
		.carousel-item {
			&.active,
			&.carousel-item-next {
				display: flex;
			}

			.carousel-caption {
				padding-top: 0;
				padding-bottom: 0;
				bottom: auto;
			}
		}
	}
}
</style>
